// Authentic primary kit/brand colour per club (used to tint club-profile headers).
export const CLUB_COLORS = {
  scottland: "#16408f",        // blue & orange
  hardrock: "#0f8a3c",         // green & yellow
  dynamos: "#1e5bb8",          // royal blue
  herentals: "#26348f",        // blue & orange (eagle)
  ngezi: "#5e2d8a",            // purple & gold
  "caps-united": "#0a8f3c",    // green & white
  highlanders: "#111827",      // black & white
  mwos: "#1f3a93",             // blue & red
  "simba-bhora": "#1b8a2e",    // green & yellow
  "chicken-inn": "#c0392b",    // red & gold
  platinum: "#0f7a3a",         // green
  "bulawayo-chiefs": "#4d7d15",// lime green & black
  kariba: "#c62828",           // ZPC red / white / blue
  hunters: "#1c3f6e",          // navy & white (tiger)
  agama: "#1746a0",            // blue & white (eagle)
  telone: "#1565c0",           // blue & white
  "manica-diamonds": "#6b5410",// black & gold
  "triangle-united": "#167a3a",// green & white
};

export const DEFAULT_CLUB_COLOR = "#0B3D2E";
